
import NativeClient from "@/client/native-client";
import { defineComponent, SetupContext, computed } from "vue";

export default defineComponent({
  name: "ShoppingListRecommendationListItem",
  props: {
    /** 画像 */
    imageUrl: {
      type: String,
      default: null
    },
    /** タイトル */
    title: {
      type: String,
      required: true
    },
    /** 食材名 */
    description: {
      type: String,
      required: true
    },
    /** 食材ID */
    id: {
      type: Number,
      required: true
    },
    /** 食材名 */
    name: {
      type: String,
      default: ""
    },
    /** レシピID */
    recipeId: {
      type: Number,
      default: 0
    }
  },
  setup(props, context: SetupContext) {
    const descriptionText = computed(() => {
     return props.description + "\n（タップで食材をリストに追加）";
    });

    // クリック
    const clickFood = () => {
      NativeClient.sendDebugLog("ShoppingListRecommendationListItem click foodId = " + props.id + ", name = " + props.name);
      NativeClient.sendDebugLog("ShoppingListRecommendationListItem click description = " + props.description);
      context.emit("click", props.id, props.name);
    };

    // 画像の取得エラー
    const onImageError = (event: Event) =>{
      NativeClient.sendDebugLog("ShoppingListRecommendationListItem onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("ShoppingListRecommendationListItem onImageError target exist");
        (event.target as HTMLImageElement).src = require("@/assets/images/noimage1.png"); 
      }
    };
    let isTouchImage = false;

    // 全体のタッチ操作
    let startX = 0;
    let startY = 0;
    let moveX = 0;
    let moveY = 0;
    const touchStart = (e: TouchEvent) => {
      NativeClient.sendDebugLog("ShoppingListRecommendationListItem touchStart e.touches[0].pageX = "+ e.touches[0].pageX);
      startX = e.touches[0].pageX;
      startY = e.touches[0].pageY;
      moveX = 0;
      moveY = 0;
    };
    const touchMove = (e: TouchEvent) => {
      //NativeClient.sendDebugLog("ShoppingListRecommendationListItem touchMove e.touches[0].pageX = " + e.touches[0].pageX);
      moveX = e.touches[0].pageX - startX;
      moveY = e.touches[0].pageY - startY;
    };
    const touchEnd = (e: TouchEvent) => {
      NativeClient.sendDebugLog("ShoppingListRecommendationListItem touchEnd moveX = " + moveX);
      //const lastX = e.touches[0].pageX;
      if (Math.abs(moveX) < 10 && Math.abs(moveY) < 10 && !isTouchImage) {
        context.emit("click", props.id, props.name, props.recipeId);
      }
    };

    // 画像のタッチ操作
    let imageTouchStartX = 0;
    let imageTouchStartY = 0;
    let imageTouchMoveX = 0;
    let imageTouchMoveY = 0;
    const imageTouchStart = (e: TouchEvent) => {
      NativeClient.sendDebugLog("ShoppingListRecommendationListItem imageTouchStart x = " + e.touches[0].pageX + ", y = " + e.touches[0].pageY);
      isTouchImage = true;
      imageTouchStartX = e.touches[0].pageX;
      imageTouchStartY = e.touches[0].pageY;
      imageTouchMoveX = 0;
      imageTouchMoveY = 0;
    };
    const imageTouchMove = (e: TouchEvent) => {
      //NativeClient.sendDebugLog("ShoppingListRecommendationListItem imageTouchMove x = " + e.touches[0].pageX + ", y = " + e.touches[0].pageY);
      imageTouchMoveX = e.touches[0].pageX - imageTouchStartX;
      imageTouchMoveY = e.touches[0].pageY - imageTouchStartY;
    };
    const imageTouchEnd = (e: TouchEvent) => {
      NativeClient.sendDebugLog("ShoppingListRecommendationListItem imageTouchEnd imageTouchMoveX = " + imageTouchMoveX + ", imageTouchMoveY = " + imageTouchMoveY);
      window.setTimeout(() => {
        isTouchImage = false;
      }, 100);
      if (Math.abs(imageTouchMoveX) < 10 && Math.abs(imageTouchMoveY) < 10) {
        NativeClient.sendDebugLog("ShoppingListRecommendationListItem imageTouchEnd click-recipe = " + props.recipeId);
        context.emit("click-recipe", props.recipeId);
      }
    };

    return {
      clickFood,
      onImageError,
      touchStart,
      touchMove,
      touchEnd,
      imageTouchStart,
      imageTouchMove,
      imageTouchEnd,
      descriptionText
    };
  }
});
